import React from 'react'
import './Home.css'
import About from '../about/About'
import Skill from '../skill/Skill'
import Project from '../project/Project'
import Contact from '../contact/Contact'


const Home = () => {
  return (
    <div className="home-container">
        <About />
        <Skill />
        <Project />
        <Contact />
    </div>
  )
}

export default Home